import React, { MouseEventHandler, useEffect, useLayoutEffect, useState } from "react";
import cn from "classnames";
import { Link, useNavigate } from "react-router-dom";
import Tag from "src/components/common/Tag";
import StoreAxisTags from "src/components/common/StoreAxisTags";
import IconButton from "../common/IconButton";
import CheckBox from "../common/CheckBox";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import { useDeleteGroupStoreMutation, useSelectGroupStoreQuery, useSelectStoreQuery } from "src/api/userAPI";
import { getPathValue } from "src/utils/queryStringUtil";
import { isEmpty } from "lodash";
import moment from "moment";

interface IShopItemProps {
  editMode?: boolean;
  deleteMode?: boolean;
  sendData?: Array<string>;
  viewData?: Array<string>;
  categoryData?: Array<string>;
  phoneData?: Array<string>;
  parentRender?: any;
  searchAPIdata?: any; // 매장 전체에 대한 데이터
  addData?: any; // 그룹에서 매장을 추가하여 등록 화면으로 이동할때
  registeredAPIdata?: any; // 그룹에 등록된 데이터
  refetchFunc?: any; // 그룹에 등록된 데이터 새로 부르기 위한 refetch
  groupAddFlag?: string;
  profileDetailClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const ShopItem = (props: IShopItemProps) => {
  // 라이브러리 사용 영역
  const group_index: any = getPathValue();
  const navigate = useNavigate();

  // 초기 값 영역
  const [init, setInit] = useState<any>({
    searchStoreList: [],
  });
  const { searchStoreList } = init;

  const [registeredAPI, setRegisteredAPI] = useState<any>({
    registerStoreList: [],
  });
  const { registerStoreList } = registeredAPI;

  const [compareRegisteredAPI, setCompareRegisteredAPI] = useState<any>({
    compareRegisterStoreList: [],
  });

  const { compareRegisterStoreList } = compareRegisteredAPI;

  const [apiSkip, setApiSkip] = useState(true);

  const [propsStore, setPropsStore] = useState<any>({
    propsSendData: props.sendData,
    propsViewData: props.viewData,
    propsCategoryData: props.categoryData,
    propsPhoneData: props.phoneData,
  });

  const { propsSendData, propsViewData, propsCategoryData, propsPhoneData } = propsStore;

  // API 영역
  // 플러스버튼을 눌러서 매장을 그룹에 추가할때 불러 searchList와 비교하기 위해 사용하는 쿼리
  // TODO 이 쿼리도 계속 부른다. 플러스버튼 누를때만 부르면 되는데
  const plusButtonClickRegisterAPI = useSelectGroupStoreQuery({ groupId: group_index, queryString: "?limit=1000" }, { skip: apiSkip });

  const [deleteGroupStoreAPI, { error, isSuccess, isLoading, isError }] = useDeleteGroupStoreMutation();

  // 생명주기 영역

  useEffect(() => {
    if (group_index) {
      setApiSkip(false);
    }
  }, [group_index]);

  useEffect(() => {
    if (props.searchAPIdata) {
      setInit({
        ...init,
        searchStoreList: props.searchAPIdata.data.data,
      });
    }
  }, [props.searchAPIdata]);

  // groupAdd에서 추가한 데이터 뿌려주기
  useEffect(() => {
    if (props.addData) {
      setInit({
        ...init,
        searchStoreList: props.addData.send,
      });
    }
  }, [props.addData]);

  // 그룹을 눌렀을때 나오는 storeList
  useEffect(() => {
    if (!isEmpty(props.registeredAPIdata)) {
      setRegisteredAPI({
        ...registeredAPI,
        registerStoreList: props.registeredAPIdata.data.data,
      });
    }
  }, [props]);

  useEffect(() => {
    if (plusButtonClickRegisterAPI.isSuccess) {
      setCompareRegisteredAPI({
        ...compareRegisteredAPI,
        compareRegisterStoreList: plusButtonClickRegisterAPI.data.data,
      });
    }
  }, [plusButtonClickRegisterAPI]);

  // 그룹의 매장을 삭제하고 성공했을때
  useEffect(() => {
    if (isSuccess) {
      // alert("삭제 되었습니다.");
      props.refetchFunc();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      alert("서버 오류 발생");
      console.log(error);
    }
  }, [isError]);

  // event 영역
  const checkedItem = (isChecked: boolean, id: string, name: string, category: string, phone: string, idx: number) => {
    // false = check
    // true = uncheck
    // 이 조건때문에 부모영역(storeList)에서의 state 값이 바뀐다.
    const newPropsData = { ...propsStore };
    if (!isChecked) {
      // check
      newPropsData.propsSendData.push(id);
      newPropsData.propsViewData.push(name);
      newPropsData.propsCategoryData.push(category);
      newPropsData.propsPhoneData.push(phone);
      // setPropsStore({
      //   ...propsStore,
      //   propsSendData: id,
      // });
    } else {
      // uncheck
      newPropsData.propsViewData.splice(idx, 1);
      newPropsData.propsSendData.splice(idx, 1);
      newPropsData.propsCategoryData.splice(idx, 1);
      newPropsData.propsPhoneData.splice(idx, 1);
      // 이렇게 지우면 또 적용이 안된다.
      // const deleteView = newPropsData.propsViewData.filter((value: any, selectIdx: number) => value !== name);
      // const deleteSend = newPropsData.propsSendData.filter((value: any, selectIdx: number) => value !== id);
      // newPropsData.propsSendData = deleteSend;
    }

    // 부모영역 새로 렌더링하기 위해 부모에서 넘긴 함수
    props.parentRender();
  };

  // 등록된 데이터에서만 삭제
  const deleteBtn = async (storeId: string, groupIndex: number) => {
    //
    if (window.confirm("해당 내용을 삭제하시겠습니까?")) {
      const deleteGroupStoreArray = [];
      const deleteGroupStoreJson = {
        group_part_idx: groupIndex,
        store_id: storeId,
      };
      deleteGroupStoreArray.push(deleteGroupStoreJson);
      await deleteGroupStoreAPI(deleteGroupStoreArray);
    }
  };

  const goDetailBtn = (userId: string) => {
    navigate("/profile/" + userId);
  };

  const goDetailBtnSecond = (userId: string) => {
    if (props.profileDetailClick) {
      props.profileDetailClick(userId, props.groupAddFlag);
    }
  };

  return (
    <>
      {searchStoreList && searchStoreList.length > 0
        ? searchStoreList.map((item: any, idx: number) => {
            let storeCheck = false;
            let pin = "";
            let sendIdx = 0;
            return (
              <>
                {/* 선택한 매장을 페이지네이션해도 계속 체크 상태로 남기기 위한 비교 */}
                {propsSendData
                  ? propsSendData.map((v: any, i: number) => {
                      //
                      if (v === item.user_id) {
                        storeCheck = true;
                        sendIdx = i;
                      }
                    })
                  : ""}
                {/* 여기가 group-add에서 기존 등록된 매장 체크상태로 만들어줌 */}
                {compareRegisterStoreList && compareRegisterStoreList.length > 0
                  ? compareRegisterStoreList.map((v2: any, i2: number) => {
                      //
                      if (v2.user_id === item.user_id) {
                        storeCheck = true;
                        pin = "A";
                        sendIdx = i2;
                      }
                    })
                  : ""}
                <ShopItemSet className={cn({ "edit-mode": props.editMode }, { "delete-mode": props.deleteMode })} key={idx}>
                  <StyledLink onClick={() => goDetailBtnSecond(item.user_id)}>
                    <div>
                      <StoreAxisTags
                        contractTypeCd={item.contract_type_cd}
                        analyticStoreType={item.analytic_store_type}
                        isPermanent={item.is_permanent}
                        storeType={item.store_type}
                        fallbackName={item.store_type_name}
                      />
                    </div>
                    <div>
                      <ManageInfo>
                        <p className="name">
                          {item.name}
                          {item.new_yn === "Y" ? <SVG name="new" width={10} height={16} viewBox="0 0 10 16" /> : ""}
                          <span className="user-id">{item.user_id}</span>
                        </p>
                      </ManageInfo>
                      <ManageDetail>
                        <p className="open">오픈 {moment(item.open_date).format("YYYY.MM.DD")}</p>
                        <div>
                          <p className={cn("rate", { disabled: item.execute_rate === 0 })}>
                            <span>{item.execute_rate > 0 ? item.execute_rate : "0"}%</span>
                          </p>
                          <div className={cn("score", { disabled: item.score === null })}>
                            <SVG name="star" width={20} height={20} viewBox="0 0 20 20" />
                            <span>{item.score >= 0 && item.score !== null ? item.score : "-"}</span>
                          </div>
                        </div>
                      </ManageDetail>
                    </div>
                  </StyledLink>
                  {props.editMode && (
                    <div className="edit-set">
                      {/* {props.deleteMode && (
                      // <IconButton btnName="추가됨" className="new">
                      //   <SVG name="checkboxActive" width={15} height={15} viewBox="0 0 20 20" />
                      // </IconButton>
                    )} */}
                      <CheckBox
                        className="check"
                        // id={`basic-check${idx}`}
                        id={item.user_id}
                        type="round"
                        onChange={(isChecked) => checkedItem(isChecked, item.user_id, item.name, item.store_type_name, item.phone_number, sendIdx)}
                        checked={storeCheck}
                        pin={pin}
                      />
                    </div>
                  )}
                </ShopItemSet>
              </>
            );
          })
        : ""}
      {!isEmpty(registerStoreList) && registerStoreList.length > 0
        ? registerStoreList.map((item: any, idx: number) => {
            let storeCheck = false;
            let sendIdx = 0;
            return (
              <>
                {propsSendData
                  ? propsSendData.map((v: any, i: number) => {
                      //
                      if (v === item.user_id) {
                        storeCheck = true;
                        sendIdx = i;
                      }
                    })
                  : ""}
                <ShopItemSet className={cn({ "edit-mode": props.editMode || props.deleteMode })} key={idx}>
                  <>
                    <StyledLink onClick={() => goDetailBtn(item.user_id)}>
                      <div>
                        <StoreAxisTags
                          contractTypeCd={item.contract_type_cd}
                          analyticStoreType={item.analytic_store_type}
                          isPermanent={item.is_permanent}
                          storeType={item.store_type}
                          fallbackName={item.store_type_name}
                        />
                      </div>
                      <div>
                        <ManageInfo>
                          <p className="name">
                            {item.name}
                            {item.new_yn === "Y" ? <SVG name="new" width={10} height={16} viewBox="0 0 10 16" /> : ""}
                            <span className="user-id">{item.user_id}</span>
                          </p>
                        </ManageInfo>
                        <ManageDetail>
                          <p className="open">오픈 {moment(item.open_date).format("YYYY.MM.DD")}</p>
                          <div>
                            <p className={cn("rate", { disabled: item.execute_rate === 0 })}>
                              <span>{item.execute_rate > 0 ? item.execute_rate : "0"}%</span>
                            </p>
                            <div className={cn("score", { disabled: item.score === null })}>
                              <SVG name="star" width={20} height={20} viewBox="0 0 20 20" />
                              <span>{item.score >= 0 && item.score !== null ? item.score : "-"}</span>
                            </div>
                          </div>
                        </ManageDetail>
                      </div>
                    </StyledLink>
                    <div className="edit-set">
                      {props.deleteMode && (
                        <IconButton btnName="삭제하기" className="delete" onClick={() => deleteBtn(item.user_id, item.group_id)}>
                          <SVG name="trDel" width={20} height={20} viewBox="0 0 20 20" />
                        </IconButton>
                      )}
                      {/* {props.editMode && (
                      <CheckBox
                        className="check"
                        // id={`basic-check${idx}`}
                        id={item.user_id}
                        type="round"
                        onChange={(isChecked) => checkedItem(isChecked, item.user_id, item.name, item.store_type_name, item.phone_number, sendIdx)}
                        checked={storeCheck}
                      />
                    )} */}
                    </div>
                  </>
                </ShopItemSet>
              </>
            );
          })
        : ""}
    </>
  );
};

const ShopItemSet = styled.li<IShopItemProps>`
  position: relative;
  &.edit-mode {
    padding-right: 40px;
  }
  &.delete-mode {
    margin: 0 -15px;
    padding: 25px 15px;
    background-color: ${({ theme }) => theme.color.bgPrimary};
    span[color="level1"] {
      background: #fff;
    }
    /* border-bottom: 1px dashed #707070; */
  }
  .edit-set {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 40px;
    > span {
      top: 20px;
      left: 15px;
    }
    label.round {
      position: relative;
      padding-left: 30px;
      height: 30px;
      > svg {
        left: 50%;
        top: 50%;
        margin-top: -12px;
        margin-left: -12px;
      }
    }
    button.delete {
      position: relative;
      top: 20px;
      left: 15px;
      width: 30px;
      height: 30px;
    }
  }
`;

const StyledLink = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "flex-start")}
  > div:first-child {
    padding-right: 10px;
  }
  > div:last-child {
    flex: 1;
  }
`;

const ManageInfo = styled.div`
  .name {
    flex-basis: 55%;
    color: #000;
    font-size: 16px;
    font-weight: 700;
    > svg {
      position: relative;
      top: -2px;
      margin-left: 5px;
    }
    .user-id {
      position: relative;
      display: inline-block;
      padding-left: 8px;
      margin-left: 8px;
      /* border-left: 2px solid ${({ theme }) => theme.color.lineSecondary}; */
      color: ${({ theme }) => theme.color.quaternary};
      font-weight: 500;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        display: block;
        width: 2px;
        height: 16px;
        margin-top: -9px;
        background: ${({ theme }) => theme.color.lineSecondary};
      }
    }
  }
`;

const ManageDetail = styled.div`
  margin-top: 10px;
  ${({ theme }) => theme.flexBox.flexMixin()}
  .open {
    color: ${({ theme }) => theme.color.quaternary};
    font-family: "Poppins";
    font-size: 14px;
  }
  .rate {
    position: relative;
    display: inline-block;
    padding-right: 8px;
    margin-right: 6px;
    > span {
      display: inline-block;
      font-family: "Poppins";
      font-size: 14px;
      font-weight: 500;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      right: 0;
      top: 50%;
      width: 1px;
      height: 12px;
      margin-top: -6px;
      background: ${({ theme }) => theme.color.lineSecondary};
    }
    &.disabled {
      opacity: 50%;
    }
  }
  .score {
    display: inline-block;
    color: #000;
    font-family: "Poppins";
    font-weight: 400;
    font-size: 14px;
    > svg {
      vertical-align: top;
    }
    > span {
      padding-left: 2px;
      vertical-align: top;
    }
    &.disabled {
      opacity: 20%;
    }
  }
`;

export default ShopItem;
